import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ModuleService } from '../../../Services/module.service';
import { TranslationService } from '../../../Services/translation.service';
import { FieldsTabsComponent } from './fields-tabs.component';
import { FieldsComponent } from './fields.component';

@Component({
    selector: 'aw-fields-container',
    templateUrl: './fields-container.component.html',
    styleUrls: ['./fields-container.component.less'],
    imports: [FieldsTabsComponent, FieldsComponent]
})
export class FieldsContainerComponent implements OnInit {
    selectedStepId: string = "";
    stepName: string;

    constructor(
        private route: ActivatedRoute,
        private moduleService: ModuleService,
        private translationService: TranslationService
    ) { }

    ngOnInit(): void {
        if (this.moduleService.selectedStep.StepName) {
            this.translationService
                .getTranslation(this.moduleService.selectedStep.StepName, 'Text')
                .subscribe(name => this.stepName = name);
        }

        this.route.queryParams.pipe(filter(params => params.stepId))
            .subscribe(params => {
                this.selectedStepId = params.stepId;
            });
    }

    showTabs(): boolean {
        return this.moduleService.selectedStep.IsMultiStep;
    }
}